export type BusinessHoursEntry = {
  days: string[];
  openTime: string;
  closeTime: string;
};

export type BusinessHoursSchedule = {
  timezone: string;
  entries: BusinessHoursEntry[];
};

function getCurrentTimeInTimezone(timezone: string, now: Date): { dayName: string; timeMinutes: number } {
  const fmt = new Intl.DateTimeFormat('en-US', {
    timeZone: timezone,
    weekday: 'short',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
  const parts = fmt.formatToParts(now);
  const dayName = parts.find((p) => p.type === 'weekday')!.value;
  const hours = parseInt(parts.find((p) => p.type === 'hour')!.value, 10);
  const minutes = parseInt(parts.find((p) => p.type === 'minute')!.value, 10);

  return { dayName, timeMinutes: hours * 60 + minutes };
}

function parseTimeToMinutes(time: string): number {
  const [hours = 0, minutes = 0] = time.split(':').map(Number);
  return hours * 60 + minutes;
}

export function isWithinBusinessHours(schedule: BusinessHoursSchedule, now?: Date): boolean {
  const current = now ?? new Date();
  const { dayName, timeMinutes } = getCurrentTimeInTimezone(schedule.timezone, current);

  for (const entry of schedule.entries) {
    if (!entry.days.includes(dayName)) continue;

    const openMinutes = parseTimeToMinutes(entry.openTime);
    const closeMinutes = parseTimeToMinutes(entry.closeTime);

    if (timeMinutes >= openMinutes && timeMinutes < closeMinutes) {
      return true;
    }
  }

  return false;
}
